import { combineReducers } from 'redux'

const rootReducer = combineReducers({
  tmp: (state = {}, action) => {
    return {}
  }
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js